"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTrackingItemEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["OrderTrackingEvent"] = "OrderTrackingEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var OrderTrackingItemEventActions;
(function (OrderTrackingItemEventActions) {
    OrderTrackingItemEventActions["OrderTrackingEventCreated"] = "OrderTrackingEventCreated";
    OrderTrackingItemEventActions["OrderTrackingEventUpdated"] = "OrderTrackingEventUpdated";
    OrderTrackingItemEventActions["OrderTrackingEventDeleted"] = "OrderTrackingEventDeleted";
    OrderTrackingItemEventActions["CreateOrderTrackingItem"] = "CreateOrderTrackingItem";
    OrderTrackingItemEventActions["UpdateOrderTrackingItem"] = "UpdateOrderTrackingItem";
    OrderTrackingItemEventActions["DeleteOrderTrackingItem"] = "DeleteOrderTrackingItem";
})(OrderTrackingItemEventActions = exports.OrderTrackingItemEventActions || (exports.OrderTrackingItemEventActions = {}));
